import React from 'react'
import { SiteSEO } from 'components/site'

const termsUrl = 'https://howxm.com/terms'
const supportEmail = 'support@howxm.com'

const Terms = () => {
  return (
    <main className="max-w-[960px] mx-auto">
      <SiteSEO title="使用条款 - 浩客HowXM" description="浩客HowXM 体验管理平台使用条款。" />
      <div>
        <h1 className="text-center">浩客使用条款</h1>
        <p>【本次更新时间：2022年11月】</p>
        <p>西安数据如金信息科技有限公司（以下简称“数据如金科技”或“我们”）</p>
        <p>您：浩客体验管理平台的注册用户（以下简称用户或“您”）</p>
        <p>
          浩客体验管理平台（以下简称“浩客”）是数据如金科技旗下的客户体验管理平台，致力于帮助企业提升全面的客户体验。主要功能为：帮助客户在多渠道、多触点聆听和分析体验数据，行动闭环管理优化体验，为客户提供体验优化方案和决策。
        </p>
        <p>
          您确认：在您开始“浩客”产品试用或购买前，您已充分阅读、理解并接受本协议的全部内容，一旦您选择“同意”并开始使用本服务或完成购买流程，即表示您同意遵循本协议之所有约定。不具备前述条件的，您应立即终止注册或停止使用本服务。
        </p>
        <p>
          数据如金科技有权根据法律法规、集团政策调整随时对本协议内容进行单方面变更，并以在howxm.com公告的方式予以公布，请您在公告处查看；
          若您在本协议内容公告变更后继续使用本服务，表示您已充分阅读、理解并接受修改后的协议内容，也将遵循修改后的协议内容使用本服务；
          若您不同意修改后的协议内容，您应停止使用本服务。 您可以访问 <a href={termsUrl}>{termsUrl}</a>{' '}
          来了解最新版本的服务条款。
        </p>
        <p>
          本条款仅适用于本产品的注册用户。如果您为本产品注册用户的终端客户（包括正在或已经向本产品数据收集页面提交数据的个人），请您注意并知悉：您的数据收集方为本产品用户，其可能是商家或品牌方等，我们仅为其提供产品与技术支持，您提交的数据将通过本产品提交给商家或品牌方。如您欲了解更多，请查看商家或品牌方的隐私政策或向其咨询。同时我们提示您，您在本产品数据收集页面（包括但不限于调研表单等）主动填写的内容，一经提交后即归于数据收集方控制，您有权拒绝填写与服务无关或不必要的信息，当其要求您填写身份证号码、手机号码、银行账号、地理位置等敏感个人信息的，请您谨慎评估风险并积极行使相关法律规定的权利。您如果需要查看、修改和删除您通过本产品提交的数据，请联系数据收集方，或联系我们协助您处理。我们的联系方式为：「
          <a href={`mailto::${supportEmail}`}>{supportEmail}</a>」
        </p>
        <h3>一、账户注册及条款</h3>
        <ol>
          <li>
            您保证具有法律规定的完全民事权利能力和民事行为能力，能够独立承担民事责任的自然人；本协议内容不会被您所属国家或地区的法律禁止。
          </li>
          <li>具体操作使用人应该是自然人。不允许采用注册机或者类似的自动化方式注册账户。</li>
          <li>当您注册时应当提供您正式的全名、邮件地址以及其他必要的信息以完成注册。</li>
          <li>您的登录信息只能用于一个人，不允许多人共享登录信息。</li>
          <li>您应当保护好自己的用户名及密码信息不被泄露。我们无法也不会保护因为您泄露用户名或密码导致的数据风险。</li>
          <li>同一个用户只能拥有一个免费账户。</li>
          <li>
            您在创建或发布体验数据收集页面收集信息时，特别是在收集填写者的个人信息和敏感个人信息（包括但不限于姓名、出生日期、身份证件号码、住址、通信通讯联系方式、账号密码、住宿信息）时，您应遵守《个人信息保护法》等相关法律和法规要求：
          </li>
          <ul>
            <li>
              您保证您收集的个人信息已取得个人信息主体主动明示的同意，并遵循法律法规及行业标准规定，采取合理有效的技术措施保存和处理表单信息。
            </li>
            <li>您需在页面首部或其他足以引起填写者注意的位置，明示收集、使用所收集信息的目的、方式和范围。</li>
            <li>
              除中所载已为个人信息主体所明示授权的范围外，您保证未经填写者明示同意，不对外披露、传输、出租、出售或交易填写者的个人信息数据，不超出体验数据收集页面填写允许的范围使用填写者信息；并且不违法使用填写者信息。
            </li>
          </ul>
          <li>
            您在使用我们的产品和服务时，如在特定合作场景下需收集终端用户数据的，您应确保在您的平台上以第三方的形式向终端用户披露我们及我们的产品或服务并取得其授权。您理解并同意，我们基于合规性的要求，会不定期对您平台的披露情况进行审查，如发现未披露或未披露充分且在与您协商后仍未合规披露的，我们将会采取暂停或中止服务的措施以保证我们的合作符合数据网络安全法规及规范。
          </li>
          <li>
            对于您以及您的账户所创建的内容负责，您不得利用“浩客”服务发布任何违反中华人民共和国法律、法规、政策的内容，从事误导、欺骗他人的行为，或宣传任何违背社会风俗、社会道德和互联网一般道德和礼仪的内容，如歧视、恐吓、诽谤、色情、淫秽等。否则，我们有权（但非义务）对上述内容予以删除，我们有权封禁您的账户及删除相关页面，且无需返还已支付的套餐费用。如果您发布了不合规内容（具体参照第8条），并在传播过程中对“浩客”品牌产生任何负面影响及造成的所有损失，由您承担，且数据如金科技将保留继续追究法律责任的权利。
          </li>
          <li>
            您不得恶意攻击“浩客”产品服务。不得复制、转售或转授权任何部分或者全部的“浩客”产品服务。不得在“浩客”产品服务中上传或者发布垃圾邮件，短信，或上传计算机病毒程序或者恶意代码，不得以口头或者文字方式攻击（包括恐吓、报复等）我们的客户、员工、成员或本产品及服务的其他使用者。
          </li>
          <li>如果您的账户流量使用明显超过平均用户带宽使用，我们保留停用您的账户的权利，直到您降低您的流量使用。</li>
          <li>
            如您在任何第三方平台发布体验数据收集页面，如微信公众平台，所发布内容亦须遵守该第三方平台相关规定。如您的页面内容含该第三方平台禁止发布的内容，如诱导分享、诱导关注，如可能或已造成对数据如金科技、浩客品牌及其他用户的危害，数据如金科技有权直接封禁用户账户及删除相关页面，且无需返还已支付的套餐费用。
          </li>
          <li>
            您在本协议期间应遵守全部中国法律、法规和规章。如果您存在任何触犯中国法律法规的行为或违反本协议的行为，数据如金科技有权根据行为的严重性自行决定立即暂停或终止您对本服务的使用，数据如金科技无须就服务暂停或终止对您承担任何责任，并且无须返还您已支付的套餐费用。
          </li>
          <li>
            如果数据如金科技因您的任何触犯中国法律法规的行为或违反本协议的行为而承受任何损失或损害，您应该采取所有行动使数据如金科技免于承担责任，并对由此产生的全部损失和损害承担赔偿责任。
          </li>
        </ol>
        <h3>二、计费与发票条款</h3>
        <ol>
          <li>收费标准以［数据如金科技产品网站所列的价格为准］。</li>
          <li>“浩客”提供免费套餐和付费套餐供您选择使用。</li>
          <li>一旦选择付费套餐、按照“浩客”要求的流程完成付款，即享有付费套餐专享的功能。</li>
          <li>
            “浩客”付费套餐服务采用先付费，后使用的方式。您需要预存或者预先支付付费套餐费用。如果您没有在付费套餐有效期结束前预先支付下个有效期的费用，即视作您主动选择终止付费套餐服务。
          </li>
          <li>预先支付的付费套餐费用无法申请退款。</li>
          <li>所有金额已经包含服务增值税。</li>
          <li>升级付费套餐时会根据您现有套餐中未使用的天数折算应扣除费用，并在新套餐付费时立即扣除。</li>
          <li>发票会按照您的要求进行寄送。您可能需要承担寄送发票的物流费用。</li>
        </ol>
        <h3>三、产品服务条款</h3>
        <ol>
          <li>
            数据如金科技将遵循《中华人民共和国网络安全法》《个人信息保护法》等法律规定和《浩客使用条款》提供浩客产品服务。数据如金科技根据前述规定，有权对用户在使用浩客产品过程中的违反法律或使用条款的行为作出处理。
          </li>
          <li>
            数据如金科技将以专业的方式提供产品及服务，但并不保证：1) 产品及服务满足您的所有需求或您的所有期待； 2)
            产品及服务没有任何失误或缺陷； 或3)
            产品及服务中的所有错误都会被修正。数据如金科技无须对任何第三方提供的产品或服务负责，亦不对第三方产品或服务提供任何保证。
          </li>
          <li>数据如金科技保留不断修改调整这项服务的权利，而无需事先通知您。</li>
          <li>
            技术支持优先提供给付费用户。数据如金科技有权就其他技术支持（如数据恢复、现场服务等）向付费用户收取服务费，服务费将遵循“浩客”公布的资费标准收取。
          </li>
          <li>若数据如金科技有任何价格调整，将在“浩客”主页上公布调整方案。</li>
        </ol>
        <h3>四、知识产权条款</h3>
        <ol>
          <li>您提交的各种内容版权归属于您。</li>
          <li>
            数据如金科技提供的服务及产品（包括但不限于观感、设计、图标、代码等）的版权、商标权、专利权及其他知识产权均归属于数据如金科技。除非获得数据如金科技明确书面允许，您不得复制、重用任何HTML/CSS,
            JavaScript或者任何视觉设计，也不得对数据如金科技产品进行反向工程、分解或进行编译或其他修改。
          </li>
          <li>本协议中未明确授予您的权利将由数据如金科技保留。</li>
        </ol>
        <h3>五、责任免除与责任限制</h3>
        <ol>
          <li>
            “浩客”是一个客户体验管理平台，对于用户所收集的客户体验数据，浩客平台所提供的服务仅为收集工具、存储数据、信息处理平台功能，数据如金科技及浩客平台除非因法律、政府及司法配合以及其他紧迫原因，并不会主动浏览、获取、使用、披露任何用户账户中收集的数据信息，用户需对其使用账户及功能的全部行为负责，因用户违法所造成数据如金科技的损失、赔偿或第三方权利主张，则用户将承担全部法律责任及赔偿，使得数据如金科技免于遭受相关责任及赔偿。
          </li>
          <li>
            您应保证使用“浩客”所收集、使用及处理的信息主体为中国大陆地区公民及法律主体。若您利用“浩客”所收集、使用及处理的信息主体为其他国家法律法规所保护的主体信息（如欧盟《一般数据保护法案》项下规定和保护之个人信息），则您应自行按照相关其他国家之法律要求及标准进行操作，若因您的违反给任何第三方造成损失或引起任何法律责任的，则您应自行承担全部赔偿及法律责任，您应使得数据如金科技在此种情形下免于任何赔偿、责任承担及费用等。
          </li>
          <li>
            在任何情况下,
            数据如金科技均无须对任何间接性、后果性、惩戒性、偶然性、特殊性或刑罚性的损害(包括但不限于您因使用数据如金科技服务而遭受的利润、收入损失、或预期的节约成本的损失或商誉损失等）承担责任，即使您已被告知该等损失的可能性。数据如金科技对您承担的全部责任总额，无论因何原因（基于合同法、侵权法或其他法规）或何种行为方式产生，始终不超过您在套餐有效期内因使用数据如金科技服务而已经支付给数据如金科技的费用。
          </li>
          <li>
            数据如金科技对您或第三方提供的应用于或操作于“浩客”的内容或与该内容相关的其他内容而引起的任何索赔或损害不承担任何责任。
          </li>
          <li>
            数据如金科技对您超出服务及服务成果适用范围使用或未遵循第三方平台使用规范发布和分享导致“浩客”服务链接失效或被第三方平台拦截、屏蔽、加入黑名单或产生其他类似效果而遭受的损失不承担任何责任。
          </li>
          <li>
            数据如金科技对您在您自身网站上使用“浩客”平台服务，因您自身网站域名失效或被封禁而导致“浩客”服务链接失效遭受的损失不承担任何责任。
          </li>
          <li>
            您了解数据如金科技使用第三方的运营商和网络提供商提供必要的硬件、软件、存储或网络来运行“浩客”服务。数据如金科技不承担因为第三方的、或者不在数据如金科技控制范围内的原因（如不可抗力）造成的运行问题（如服务中断、停顿、中止等）负责。
          </li>
          <li>
            如果您使用浩客发布侵犯他人知识产权或其他合法权益的内容，经相关方提供初步证据，数据如金科技有权先行予以删除，并保留移交司法机关查处的权利。参照相应司法机关的查处结果，数据如金科技对于网站发布内容的处置具有最终决定权。
          </li>
          <li>
            您理解并同意：使用浩客免费账户创建的体验数据收集页面，一经发布即成为公开信息，互联网用户可能通过搜索引擎搜索到您的页面内容，您理解并同意使用浩客发布体验数据收集页面所存在的上述风险，并完全由当前账户拥有者承担。
          </li>
          <li>
            本责任限制条款适用于《浩客使用条款》及您基于“浩客”平台服务与数据如金科技签订的全部线上线下合作协议及补充协议。
          </li>
        </ol>
        <h3>六、服务取消与终止条款</h3>
        <ol>
          <li>
            您的账户一旦被终止，除非按照您的其他指示，“浩客”将按照法律及相关法规规定，对这个账户的数据保留6个月，此期间只有账户管理员能够登录系统，执行查询、数据备份相关操作，之后数据会被从服务器彻底删除，并且无法恢复。
          </li>
          <li>如果终止操作发生在套餐有效期内，数据如金科技将不提供任何退费。</li>
          <li>一旦终止账户，在数据保留期内，账户下的所有功能及服务将无法使用。</li>
        </ol>
        <h3>七、其他条款</h3>
        <ol>
          <li>
            如果本协议的某一条款或某一条款的一部分无效或不可执行，不影响本协议其他条款的有效性，无效或不可执行的条款将被视作已从本协议中删除。
          </li>
          <li>
            本协议受中华人民共和国法律管辖。
            在执行本协议过程中如发生纠纷，双方应及时协商解决。协商不成时，任何一方均应向西安市雁塔区人民法院提起诉讼。
          </li>
          <li>本条款最新修订于2022年11月，最终解释权归数据如金科技所有。</li>
          <li>若有任何疑问，请发信至support@howxm.com</li>
        </ol>
        <p>联系地址：陕西省西安市高新区高新五路4号汇诚国际16楼</p>
        <p>至此，您已经详细阅读并已理解本协议，并同意严格遵守各条款和条件。</p>
      </div>
    </main>
  )
}

export const getStaticProps = async () => {
  return {
    props: {
      pageTitle: '使用条款',
    },
  }
}

export default Terms
